import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Container,
  Row,
  Tab,
  Nav,
  Button,
  Spinner,
  Accordion,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  useCancelOrderMutation,
  useChangeGroupedOrderStatusMutation,
  useChangeMealStatusMutation,
  useGetGroupedOrderInfoQuery,
  useUpdateGroupMutation,
  useGetOrderDetailsQuery,
  useGetOrderNewQuery,
  useUpdateOrderMutation,
} from "../../../../store/services/orderService";
import moment from "moment";
import toast from "react-hot-toast";
import styles from "../../Orders/Detail/orderDetail.module.scss";
import detailStyles from "./details.module.scss";
import {
  macrosBarDynamicPercentage,
  priceCurrency,
} from "../../../../helpers/common";
import OrderMealDetail from "../../../../components/Modals/OrderMealDetail";
import DatesHeader from "../../Orders/DatesHeader";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";

// Function to format the date array into the desired format
const formatDateArray = (dateArray) => {
  // Use Set to get unique dates
  const uniqueDates = [...new Set(dateArray)];

  return uniqueDates.map((dateStr) => {
    const date = moment(dateStr);
    return {
      day: date.format("dddd"), // Day of the week
      dateLabel: date.format("DD/MM"), // Date in "DD/MM" format
      date: date.toISOString(), // ISO format date
    };
  });
};

const StoreOrderDetail = () => {
  const { id, from } = useParams();
  const {
    data: order,
    error,
    isLoading,
    isSuccess,
  } = useGetGroupedOrderInfoQuery({
    pageNo: 1,
    limit: 10,
    orderBy: "createdAt",
    order: 1,
    orderId: id,
  });

  const [selectedDay, setSelectedDay] = useState(null);
  console.log(selectedDay, "selectedDay");

  const [selectedMeal, setSelectedMeal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const [selectedMeals, setSelectedMeals] = useState([]);
  const [selectedMealStatus, setSelectedMealStatus] = useState(null);
  const [updateOrder, { isLoading: isUpdating }] = useCancelOrderMutation();
  const [dateOptions, setDateOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({ date: "", qty: "" });

  const [updateQuantity] = useUpdateGroupMutation();
  const [updateMealStatus, { isLoading: isUpdatingMealStatus }] =
    useChangeMealStatusMutation();
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [
    updateGroupedOrderStatus,
    { isLoading: isUpdatingGroupedOrderStatus, isFetching },
  ] = useChangeGroupedOrderStatusMutation();
  const [activeButton, setActiveButton] = React.useState(null);

  const [confirmationGroupOrderStatus, setConfirmationGroupOrderStatus] =
    useState(false);
  const [
    confiramtionGroudOrderStatusData,
    setConfirmationGroupOrderStatusData,
  ] = useState(null);

  const handleStatusUpdate = async () => {
    try {
      const res = await updateOrder({
        orderId: id,
        status: "cancelled",
        cancelledAt: new Date(),
      }).unwrap();
      toast.success(res?.message);
    } catch (error) {
      console.error("Failed to update the order:", error);
      // toast.error("Failed to update the order. Please try again.");
    } finally {
      setCancelConfirmation(false);
    }
  };

  const handleQuantity = async (id, qty, index) => {
    console.log(
      selectedMeals?.[0]?.products[index]?.date,
      "selectedMeals?.[0]?.products[index]?.date"
    );
    if (selectedMeals?.[0]?.products[index]?.date == "") {
      toast.error("Please select date");
      return;
    }
    console.log(
      selectedMeals?.[0]?.products[index]?.quantityNew,
      "selectedMeals?.[0]?.products[index]?.date"
    );
    try {
      let body = {
        toMealId:
          selectedMeals?.[0]?.products[index]?.date ||
          selectedMeals?.[0]?.products[index]?._id,
        quantity: selectedMeals?.[0]?.products[index]?.quantityNew || qty,
        productId: id,
      };

      const res = await updateQuantity({
        updatedData: body,
        // New API expects sub-order id (data?.meals?._id) in the path param
        userId: selectedDay?._id,
      }).unwrap(); // Await API response
      toast.success(res?.message);
    } catch (error) {
      console.error("Failed to update the order:", error);
      // toast.error("Failed to update the order. Please try again.");
    } finally {
      setCancelConfirmation(false);
    }
  };
  useEffect(() => {
    if (selectedDay) {
      // Build dates from all meals for the selected sub-order (API now provides products at sub-order level)
      const preparingDates = selectedDay?.meals?.map(
        (item) => item.preparingDate
      );
      const dates = formatDateArray(preparingDates);

      setDates(dates);
      if (!selectedDate) {
        setSelectedDate(dates?.[0]?.date);
      } else if (!dates?.some((d) => d.date === selectedDate)) {
        setSelectedDate(dates?.[0]?.date);
      }
    }
  }, [selectedDay]);
  useEffect(() => {
    if (order?.data?.meals?.length > 0) {
      const firstOrder =
        selectedDay === null
          ? order?.data?.meals[0]
          : order?.data?.meals?.find(
              (it) => it.subOrderID === selectedDay?.subOrderID
            );

      setSelectedDay(firstOrder);
    }
  }, [order]);

  const selectedMealsInfo = useMemo(() => {
    if (!selectedDay || !selectedDate) return [];

    return (
      selectedDay?.meals?.filter((item) =>
        moment(item?.preparingDate).isSame(selectedDate, "day")
      ) || []
    );
  }, [selectedDay, selectedDate, id]);

  useEffect(() => {
    console.log(selectedMealsInfo, "selectedMealsInfoInEffe");
    const res = selectedMealsInfo?.map((item) => {
      // If meal-level products are empty (as per new API), fall back to sub-order products
      const sourceProducts =
        item?.products && item.products.length > 0
          ? item.products
          : selectedDay?.products || [];

      return {
        ...item,
        products: sourceProducts?.map((it) => ({
          ...it,
          date: "",
          quantityNew: "",
        })),
      };
    });
    console.log(res, "wer");
    setSelectedMeals(res);

    // setSelectedMeals(selectedMealsInfo)
  }, [selectedMealsInfo, selectedDay, selectedDate, id]);
  console.log(selectedMeals, "selectedMealsert");
  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  const handleChangeStatus = async (status) => {
    try {
      const resp = await updateMealStatus({
        id: selectedMealStatus?._id,
        data: { status: "prepared", preparedAt: new Date() },
      }).unwrap();

      toast.success(resp.message);
      setConfirmation(false);
    } catch (error) {}
  };

  const handleDateChange = (e, mealIndex, productIndex) => {
    console.log(productIndex, "product");
    setSelectedMeals((prev) => {
      const updated = [...prev];
      updated[mealIndex] = {
        ...updated[mealIndex],
        products: updated[mealIndex].products.map((product, idx) =>
          idx === productIndex ? { ...product, date: e.target.value } : product
        ),
      };
      console.log(updated, "updated");
      return updated;
    });
  };

  // Update handler for quantity selection
  const handleQuantityChange = (e, mealIndex, productIndex) => {
    setSelectedMeals((prev) => {
      const updated = [...prev];
      updated[mealIndex] = {
        ...updated[mealIndex],
        products: updated[mealIndex].products.map((product, idx) =>
          idx === productIndex
            ? { ...product, quantityNew: e.target.value }
            : product
        ),
      };
      console.log(updated, "updated1");
      return updated;
    });
  };

  const handleGroupedOrderStatus = async () => {
    try {
      const { _id, ...rest } = confiramtionGroudOrderStatusData;
      const orderType = order?.data?.order?.type;

      // Use different APIs based on status
      if (rest?.status === "prepared" && orderType !== 3) {
        // Use prepareMeal API for prepared status
        const resp = await updateMealStatus({
          data: {
            status: rest.status,
            ...rest,
          },
          id: order?.data?.order?._id,
        }).unwrap();

        toast.success(resp.message);
      } else {
        // Use grouped order API for other statuses (inTransit, delivered, etc.)
        const resp = await updateGroupedOrderStatus({
          id: _id,
          data: {
            ...rest,
          },
        }).unwrap();

        toast.success(resp.message);
      }

      setConfirmationGroupOrderStatus(false);
      setConfirmationGroupOrderStatusData(null);
    } catch (error) {
      console.error("Failed to update order status:", error);
      // toast.error("Failed to update order status. Please try again.");
    }
  };

  const handleProductOrderStatus = async () => {
    try {
      const { _id, ...rest } = confiramtionGroudOrderStatusData;

      const orderId = _id || order?.data?.order?._id;
      const orderType = order?.data?.order?.type;

      if (orderType === 3) {
        const resp = await updateGroupedOrderStatus({
          id: orderId,
          data: {
            ...rest,
          },
        }).unwrap();
        toast.success(resp.message);
      } else {
        const resp = await updateMealStatus({
          data: {
            status: rest.status,
            ...rest,
          },
          id: orderId,
        }).unwrap();
        toast.success(resp.message);
      }
      setConfirmationGroupOrderStatus(false);
      setConfirmationGroupOrderStatusData(null);
    } catch (error) {
      console.error("Failed to update product order status:", error);
      // toast.error("Failed to update order status. Please try again.");
    }
  };

  const renderButton = (selectedDay) => {
    const isProductList =
      !order?.data?.meals || order?.data?.meals?.length === 0;

    // Get order type from the order data
    const orderType = order?.data?.order?.type;

    switch (selectedDay?.status) {
      case "confirmed":
        if (orderType === 3) {
          return (
            <>
              <Button
                className="d-inline-flex align-items-center justify-content-center commonBtn"
                onClick={() => {
                  const buttonData = {
                    status: "inTransit",
                    intransitAt: new Date(),
                    _id: selectedDay._id,
                  };
                  setConfirmationGroupOrderStatusData(buttonData);
                  setConfirmationGroupOrderStatus(true);
                }}
                disabled={isUpdatingGroupedOrderStatus}
              >
                Mark the order as 'In Transit'
              </Button>
            </>
          );
        }
        return (
          <>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn ml-2"
              onClick={() => {
                const buttonData = {
                  status: "prepared",
                  preparedAt: new Date(),
                  _id: selectedDay._id,
                };
                setConfirmationGroupOrderStatusData(buttonData);
                setConfirmationGroupOrderStatus(true);
              }}
              disabled={isUpdatingGroupedOrderStatus}
            >
              Mark the order as 'Prepared'
            </Button>
          </>
        );
      case "prepared":
        return (
          <>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn"
              onClick={() => {
                const buttonData = {
                  status: "inTransit",
                  intransitAt: new Date(),
                  _id: selectedDay._id,
                };
                setConfirmationGroupOrderStatusData(buttonData);
                setConfirmationGroupOrderStatus(true);
              }}
              disabled={isUpdatingGroupedOrderStatus}
            >
              Mark the order as 'In Transit'
            </Button>
            {orderType === 2 && (
              <Button
                className="d-inline-flex align-items-center justify-content-center commonBtn ml-2"
                disabled
              >
                Order is currently 'Prepared'
              </Button>
            )}
          </>
        );
      case "inTransit":
        return (
          <>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn"
              onClick={() => {
                const buttonData = {
                  status: "delivered",
                  deliveredAt: new Date(),
                  _id: selectedDay._id,
                };
                setConfirmationGroupOrderStatusData(buttonData);
                setConfirmationGroupOrderStatus(true);
              }}
              disabled={isUpdatingGroupedOrderStatus}
            >
              Mark the order as 'Delivered'
            </Button>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn ml-2"
              disabled
            >
              Order is currently 'In Transit'
            </Button>
          </>
        );
      case "delivered":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            Order is already marked as 'Delivered'
          </Button>
        );
      case "paused":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            This order is paused
          </Button>
        );
      case "cancelled":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            This order is cancelled
          </Button>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (isSuccess) {
      // Show dates from API key: preparingDates for the Select Date dropdown
      setDateOptions(order?.data?.preparingDates || []);
    }
  }, [isSuccess, order]);
  console.log(selectedMealsInfo, "selectedMealsInfo");
  return (
    <>
      <ConfirmationPop
        type={"confirmation"}
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        confirmHandler={handleChangeStatus}
      />
      <ConfirmationPop
        type={"confirmation"}
        confirmation={confirmationGroupOrderStatus}
        setConfirmation={setConfirmationGroupOrderStatus}
        confirmHandler={
          order?.data?.meals?.length > 0
            ? handleGroupedOrderStatus
            : handleProductOrderStatus
        }
      />
      <ConfirmationPop
        type={"confirmation"}
        confirmation={cancelConfirmation}
        setConfirmation={setCancelConfirmation}
        confirmHandler={handleStatusUpdate}
      />
      {modalOpen && (
        <OrderMealDetail
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          title={selectedMeal?.name}
          meal={selectedMeal}
        />
      )}
      <section className={`${styles.ordersec} py-5 position-relative`}>
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to={
                    from == "today"
                      ? "/store-order-management-today"
                      : "/store-order-management"
                  }
                  className="border d-flex align-align-align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  Order Detail
                </h4>
              </div>
            </Col>
            {isLoading && (
              <div className="text-center">
                <div className="spinner-border text-dark" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </Row>
          {!isLoading && (
            <Row className="mx-auto" style={{ maxWidth: 1024 }}>
              {order?.data?.order?.status === "paused" &&
                order?.data?.order?.pausedAt && (
                  <Col lg="12">
                    <div className="alert alert-danger" role="alert">
                      This order has been paused from{" "}
                      {moment().diff(
                        moment(order?.data?.order?.pausedAt),
                        "days"
                      )}{" "}
                      {moment().diff(
                        moment(order?.data?.order?.pausedAt),
                        "days"
                      ) === 1
                        ? "day"
                        : "days"}
                      .{/* Please contact the customer. */}
                    </div>
                  </Col>
                )}
              <Col lg="12" className="my-2">
                <div className="mx-auto">
                  <div className="cardCstm bg-light rounded-3 p-2 px-3">
                    <div className="top p-2 d-d-flex align-align-align-items-center justify-content-between border-bottom  d-d-flex-wrap">
                      <h5 className="m-0 fw-sbold">
                        {order?.data?.meals?.length > 0
                          ? "Order List"
                          : "Product List"}
                      </h5>
                      <p className="m-0 text-muted">
                        {" "}
                        Order Id : {order?.data?.order?.orderID}
                      </p>
                    </div>
                    <div className="contentBody">
                      {order?.data?.meals?.length > 0 ? (
                        // Meal-based order list (existing logic)
                        <Row>
                          <Col sm="2" className="my-2">
                            <Accordion
                              defaultActiveKey="0"
                              style={{ width: "147px", margin: "0 auto" }}
                            >
                              {order?.data?.meals?.length > 0 &&
                                order?.data?.meals?.map((item, index) => (
                                  <Accordion.Item
                                    // className={`${styles.accordionItm} ${item?.status == "" } bg-danger bg-success bg-warning `}
                                    className={`${styles.accordionItm} ${
                                      item?.status === "cancelled"
                                        ? "bg-danger"
                                        : item?.status === "confirmed"
                                        ? "bg-success"
                                        : item?.status === "delivered"
                                        ? "bg-primary"
                                        : item?.status === "paused"
                                        ? "bg-secondary"
                                        : item?.status === "onTheWay"
                                        ? "bg-info"
                                        : item?.status === "inTransit"
                                        ? "bg-warning"
                                        : "bg-warning"
                                    }`}
                                    eventKey={index.toString()}
                                    key={item?.week}
                                  >
                                    <Accordion.Header
                                      className={`${styles.accordionHeader}`}
                                    >
                                      {/* {`Delivery Date ${index + 1}`} */}
                                      {/* {`Delivery date ${selectedDay?.subOrderID}`} */}
                                      {`Delivery date ${
                                        item?.subOrderID || index + 1
                                      }`}
                                    </Accordion.Header>
                                    <Accordion.Body className="px-1 py-0">
                                      <ul className="list-unstyled ps-0 mb-0">
                                        {/* {item?.preparingDates?.length > 0 &&
                                          item?.preparingDates.map(
                                            (date, idx) => ( */}
                                        <li className="py-2">
                                          <div
                                            className={`text-center position-relative p-2 rounded cursor-pointer ${
                                              moment(
                                                selectedDay?.deliveryDate
                                              )?.format("YYYY-MM-DD") ===
                                              moment(
                                                item?.deliveryDate
                                              )?.format("YYYY-MM-DD")
                                                ? "bg-[#3E0799] text-white"
                                                : "text-gray-400"
                                            }`}
                                            style={{
                                              background:
                                                moment(
                                                  selectedDay?.deliveryDate
                                                )?.format("YYYY-MM-DD") ===
                                                moment(
                                                  item?.deliveryDate
                                                )?.format("YYYY-MM-DD")
                                                  ? "#3E0799"
                                                  : "",
                                            }}
                                            onClick={() => setSelectedDay(item)}
                                          >
                                            <h6 className="m-0 fw-sbold py-1">
                                              {moment(
                                                item?.deliveryDate
                                              ).format("dddd")}
                                            </h6>
                                            <p className="m-0">
                                              {moment(
                                                item?.deliveryDate
                                              ).format("DD/MM")}
                                            </p>
                                          </div>
                                        </li>
                                        {/* )
                                          )} */}
                                      </ul>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                ))}
                            </Accordion>
                          </Col>
                          <Col sm="10" className="my-2">
                            <Row>
                              <Col lg="12">
                                <div className="d-flex align-items-center justify-content-between  text-end">
                                  <div>
                                    Status :{" "}
                                    <span className="text-[#3E0799] fw-bold text-uppercase">
                                      {selectedDay?.status}
                                    </span>
                                  </div>
                                  <div>
                                    Sub order ID :{" "}
                                    <span className="text-[#3E0799] fw-bold text-uppercase">
                                      {selectedDay?.subOrderID}
                                    </span>
                                  </div>
                                  {renderButton(selectedDay)}
                                </div>
                              </Col>
                              <Col sm="10" className="my-2">
                                <DatesHeader
                                  selectedDate={selectedDate}
                                  dates={dates?.slice(0, 1)}
                                  canSwitchDate={true}
                                  setSelectedDate={setSelectedDate}
                                  arrowShow={false}
                                />
                              </Col>

                              {/* Products Section */}
                              {selectedMeals?.length > 0 &&
                                selectedMeals[0]?.products?.length > 0 && (
                                  <Col lg="12" className="my-3">
                                    <h6 className="m-0 py-2 text-center fw-sbold text-dark">
                                      Products
                                    </h6>
                                    <Row>
                                      {selectedMeals[0]?.products?.map(
                                        (product, index) => {
                                          // Get product details - handle both object and string references

                                          const productDetails =
                                            typeof product.productId ===
                                            "object"
                                              ? product.productId
                                              : { name: "Product" };
                                          const flavourDetails =
                                            typeof product.flavourId ===
                                            "object"
                                              ? product.flavourId
                                              : { name: "Flavour" };
                                          const sizeDetails =
                                            typeof product.sizeId === "object"
                                              ? product.sizeId
                                              : { name: "Size" };

                                          const variationLabel1 =
                                            product?.productId
                                              ?.variationType === 2
                                              ? "Color"
                                              : "Flavour";
                                          return (
                                            <Col sm="4" key={index}>
                                              <div
                                                className={`${styles.cardCstm} cardCstm border rounded`}
                                              >
                                                <div className="imgWrp">
                                                  <img
                                                    src={
                                                      flavourDetails
                                                        ?.images?.[0] ||
                                                      productDetails?.image ||
                                                      "https://via.placeholder.com/300x200?text=Product"
                                                    }
                                                    alt=""
                                                    loading="lazy"
                                                    width={1000}
                                                    height={10000}
                                                    decoding="async"
                                                    className="w-full img-fluid object-fit-cover"
                                                    style={{
                                                      height: 150,
                                                      color: "transparent",
                                                      borderTopLeftRadius: 5,
                                                      borderTopRightRadius: 5,
                                                    }}
                                                  />
                                                </div>
                                                <div className="contentBody">
                                                  <h6 className="m-0 fw-sbold p-2 pb-1">
                                                    {productDetails?.name}
                                                  </h6>
                                                  <div className="p-2">
                                                    <p className="m-0 text-muted small">
                                                      {variationLabel1}:{" "}
                                                      {flavourDetails?.name}
                                                    </p>
                                                    <div className="d-flex align-items-center gap-2 mt-2">
                                                      {sizeDetails
                                                        ?.images?.[0] && (
                                                        <img
                                                          src={
                                                            sizeDetails
                                                              .images[0]
                                                          }
                                                          alt=""
                                                          style={{
                                                            width: 30,
                                                            height: 30,
                                                            objectFit: "cover",
                                                            borderRadius: 4,
                                                          }}
                                                        />
                                                      )}
                                                      <span className="text-dark fw-medium">
                                                        Size:{" "}
                                                        {sizeDetails?.name}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <h6 className="price p-2 text-base text-center fw-sbold">
                                                    {priceCurrency(
                                                      product.price
                                                    )}
                                                  </h6>
                                                  <div className="pt-1 pb-2 btnWrpper px-2">
                                                    <div className="py-1">
                                                      <button
                                                        className={`${styles.submitBtn} d-flex align-items-center fw-bold justify-content-center btn w-100`}
                                                        disabled
                                                      >
                                                        Qty: {product.quantity}
                                                      </button>
                                                    </div>
                                                  </div>
                                                  {![
                                                    "intransit",
                                                    "delivered",
                                                  ].includes(
                                                    (
                                                      selectedDay?.status || ""
                                                    ).toLowerCase()
                                                  ) && (
                                                    <div className="pt-1 pb-2 btnWrpper px-2">
                                                      <select
                                                        id="productType"
                                                        className={
                                                          detailStyles.dateSelect
                                                        }
                                                        displayEmpty
                                                        value={product?.date}
                                                        onChange={(e) =>
                                                          handleDateChange(
                                                            e,
                                                            0,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Select Date
                                                        </option>
                                                        {dateOptions?.map((item) => {
                                                          const statusLower = (item?.status || "").toLowerCase();
                                                          const isCurrentDate =
                                                            item?._id === selectedDay?._id ||
                                                            (item?.deliveryDate && selectedDay?.deliveryDate &&
                                                              moment(item?.deliveryDate).isSame(
                                                                selectedDay?.deliveryDate,
                                                                "day"
                                                              ));
                                                          const isDisabled =
                                                            statusLower === "delivered" ||
                                                            statusLower === "intransit" ||
                                                            isCurrentDate;
                                                          return (
                                                            <option
                                                              key={item?._id}
                                                              disabled={isDisabled}
                                                              value={item?._id}
                                                            >
                                                              {item?.deliveryDate
                                                                ? moment(item?.deliveryDate).format(
                                                                    "DD-MM-YYYY"
                                                                  )
                                                                : ""}
                                                            </option>
                                                          );
                                                        })}
                                                      </select>
                                                    </div>
                                                  )}
                                                  {![
                                                    "intransit",
                                                    "delivered",
                                                  ].includes(
                                                    (
                                                      selectedDay?.status || ""
                                                    ).toLowerCase()
                                                  ) && (
                                                    <div className="pt-1 pb-2 btnWrpper px-2">
                                                      <select
                                                        id="productType"
                                                        className={
                                                          detailStyles.quantitySelect
                                                        }
                                                        defaultValue=""
                                                        value={
                                                          product.quantityNew
                                                        }
                                                        onChange={(e) =>
                                                          handleQuantityChange(
                                                            e,
                                                            0,
                                                            index
                                                          )
                                                        } // Assuming mealIndex is always 0
                                                      >
                                                        <option value="">
                                                          Select quantity
                                                        </option>
                                                        {Array.from(
                                                          {
                                                            length:
                                                              product?.quantity,
                                                          },
                                                          (_, i) => (
                                                            <option
                                                              key={i + 1}
                                                              value={i + 1}
                                                            >
                                                              {i + 1}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </div>
                                                  )}
                                                  {![
                                                    "intransit",
                                                    "delivered",
                                                  ].includes(
                                                    (
                                                      selectedDay?.status || ""
                                                    ).toLowerCase()
                                                  ) && (
                                                    <div className="pt-1 pb-2 btnWrpper px-2">
                                                      <button
                                                        className={`${styles.submitBtn} d-flex align-items-center fw-bold`}
                                                        onClick={() =>
                                                          handleQuantity(
                                                            product?._id,
                                                            product?.quantity,
                                                            index
                                                          )
                                                        }
                                                        type="button"
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </Col>
                                          );
                                        }
                                      )}
                                    </Row>
                                  </Col>
                                )}

                              {/* Meals Section - Removed to show only product cards */}
                            </Row>
                          </Col>
                        </Row>
                      ) : (
                        // Product-based order list (new logic)
                        <Row>
                          <Col lg="12" className="my-3">
                            <div className="d-flex align-items-center justify-content-between text-end mb-3">
                              <div>
                                Status :{" "}
                                <span className="text-[#3E0799] fw-bold text-uppercase">
                                  {order?.data?.order?.status}
                                </span>
                              </div>
                              <div>
                                Order ID :{" "}
                                <span className="text-[#3E0799] fw-bold text-uppercase">
                                  {order?.data?.order?.orderID}
                                </span>
                              </div>
                              {(() => {
                                const buttonData = {
                                  status: order?.data?.order?.status,
                                  _id: order?.data?.order?._id,
                                };
                                return renderButton(buttonData);
                              })()}
                            </div>
                            <h6 className="m-0 py-2 text-center fw-sbold text-dark">
                              Products
                            </h6>
                            <Row>
                              {order?.data?.order?.products?.map(
                                (product, index) => {
                                  // Get product details - handle both object and string references
                                  const productDetails =
                                    typeof product.productId === "object"
                                      ? product.productId
                                      : { name: "Product" };

                                  const flavourDetails =
                                    typeof product.flavourId === "object"
                                      ? product.flavourId
                                      : { name: "Flavour" };

                                  const sizeDetails =
                                    typeof product.sizeId === "object"
                                      ? product.sizeId
                                      : { name: "Size" };

                                  // Decide label based on variationType
                                  const variationLabel =
                                    product?.productId?.variationType === 2
                                      ? "Color"
                                      : "Flavour";

                                  return (
                                    <Col sm="4" key={index}>
                                      <div
                                        className={`${styles.cardCstm} cardCstm border rounded`}
                                      >
                                        <div className="imgWrp">
                                          <img
                                            src={
                                              flavourDetails?.images?.[0] ||
                                              productDetails?.image ||
                                              "https://via.placeholder.com/300x200?text=Product"
                                            }
                                            alt=""
                                            loading="lazy"
                                            width={1000}
                                            height={10000}
                                            decoding="async"
                                            className="w-full img-fluid object-fit-cover"
                                            style={{
                                              height: 150,
                                              color: "transparent",
                                              borderTopLeftRadius: 5,
                                              borderTopRightRadius: 5,
                                            }}
                                          />
                                        </div>
                                        <div className="contentBody">
                                          <h6 className="m-0 fw-sbold p-2 pb-1">
                                            {productDetails?.name}
                                          </h6>
                                          <div className="p-2">
                                            <p className="m-0 text-muted small">
                                              {console.log(
                                                variationLabel,
                                                "DATA"
                                              )}
                                              {variationLabel}:{" "}
                                              {flavourDetails?.name}
                                            </p>
                                            <div className="d-flex align-items-center gap-2 mt-2">
                                              {sizeDetails?.images?.[0] && (
                                                <img
                                                  src={sizeDetails.images[0]}
                                                  alt=""
                                                  style={{
                                                    width: 30,
                                                    height: 30,
                                                    objectFit: "cover",
                                                    borderRadius: 4,
                                                  }}
                                                />
                                              )}
                                              <span className="text-dark fw-medium">
                                                Size: {sizeDetails?.name}
                                              </span>
                                            </div>
                                          </div>
                                          <h6 className="price p-2 text-base text-center fw-sbold">
                                            {priceCurrency(product.price)}
                                          </h6>
                                          <div className="pt-1 pb-2 btnWrpper px-2">
                                            <div className="py-1">
                                              <button
                                                className={`${styles.submitBtn} d-flex align-items-center fw-bold justify-content-center btn w-100`}
                                                disabled
                                              >
                                                Qty: {product.quantity}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  );
                                }
                              )}
                            </Row>
                          </Col>
                        </Row>
                      )}

                      {/* Free Products Section - Only show when freeProducts array has values */}
                      {(() => {
                        // Decide the source of free products based on order type
                        const orderType = order?.data?.order?.type;
                        const firstSubOrder = order?.data?.meals?.[0];
                        let allFreeProducts = [];

                        if (orderType === 2) {
                          // Product-only orders contain free products directly on the order object
                          allFreeProducts = order?.data?.order?.freeProducts || [];
                        } else {
                          // Meal-based orders: free products are attached at sub-order level
                          allFreeProducts = firstSubOrder?.freeProducts || [];
                        }

                        // Decide visibility: show always for product-only orders (type 2)
                        // For orders with meals (type 3/others), show ONLY on the first sub-order's first date
                        let shouldShow = false;
                        if (orderType === 2) {
                          shouldShow = true;
                        } else {
                          const isFirstSubOrderSelected =
                            selectedDay?.subOrderID === firstSubOrder?.subOrderID;

                          const firstSubOrderFirstDate = (() => {
                            const mealDates = (firstSubOrder?.meals || []).map((m) => m?.preparingDate);
                            if (!mealDates?.length) return null;
                            return moment(mealDates[0]).toISOString();
                          })();

                          const isFirstDateSelected =
                            !!selectedDate &&
                            !!firstSubOrderFirstDate &&
                            moment(selectedDate).isSame(firstSubOrderFirstDate, "day");

                          shouldShow = isFirstSubOrderSelected && isFirstDateSelected;
                        }

                        // Only render if we have free products and visibility rule passes
                        if (allFreeProducts.length > 0 && shouldShow) {
                          return (
                            <Row>
                              <Col lg="12" className="my-3">
                                <h6 className="m-0 py-2 text-center fw-sbold text-dark">
                                  Free Products (Promo Code Applied)
                                </h6>
                                <Row>
                                  {allFreeProducts?.map((product, index) => {
                                    // Get product details - handle both object and string references
                                    const productDetails =
                                      typeof product.productId === "object"
                                        ? product.productId
                                        : { name: "Product" };
                                    const flavourDetails =
                                      typeof product.flavourId === "object"
                                        ? product.flavourId
                                        : { name: "Flavour" };
                                    const sizeDetails =
                                      typeof product.sizeId === "object"
                                        ? product.sizeId
                                        : { name: "Size" };

                                    return (
                                      <Col sm="4" key={index}>
                                        <div
                                          className={`${styles.cardCstm} cardCstm border rounded`}
                                          style={{
                                            border: "2px solid #28a745",
                                          }}
                                        >
                                          <div className="imgWrp">
                                            <img
                                              src={
                                                flavourDetails?.images?.[0] ||
                                                productDetails?.image ||
                                                "https://via.placeholder.com/300x200?text=Product"
                                              }
                                              alt=""
                                              loading="lazy"
                                              width={1000}
                                              height={10000}
                                              decoding="async"
                                              className="w-full img-fluid object-fit-cover"
                                              style={{
                                                height: 150,
                                                color: "transparent",
                                                borderTopLeftRadius: 5,
                                                borderTopRightRadius: 5,
                                              }}
                                            />
                                          </div>
                                          <div className="contentBody">
                                            <h6 className="m-0 fw-sbold p-2 pb-1">
                                              {productDetails?.name}
                                            </h6>
                                            <h6 className="price p-2 text-base text-center fw-sbold text-success">
                                              FREE
                                            </h6>
                                            <div className="pt-1 pb-2 btnWrpper px-2">
                                              <div className="py-1">
                                                <button
                                                  className={`${styles.submitBtn} d-flex align-items-center fw-bold justify-content-center btn w-100`}
                                                  disabled
                                                >
                                                  Qty: {product.quantity}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Col>
                                    );
                                  })}
                                </Row>
                              </Col>
                            </Row>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  </div>
                </div>
              </Col>

              <Col md="6" className="my-2">
                {/* Hide Spicy Level for product-only orders */}
                {order?.data?.meals?.length > 0 && (
                  <div className="cardCstm bg-light rounded-3 p-2 px-3 mb-3">
                    <ul className="list-unstyled pl-0 mb-0">
                      <li className="py-2 border-bottom">
                        <div className="py-1">
                          <h6 className="m-0 fw-sbold text-base pb-1">
                            Spicy Level
                          </h6>
                          {order?.data?.order?.spicyLevel || "No data found!"}
                          <p className="m-0 text-gray-500">{}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}
                <div className="cardCstm bg-light rounded-3 p-2 px-3">
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Customer Name
                        </h6>
                        {order?.data?.order?.deliveryAddress?.fullName}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Phone Number
                        </h6>
                        {order?.data?.order?.deliveryAddress?.phoneNumber}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Delivery Address
                        </h6>
                        <p className="m-0 text-gray-500">
                          {order?.data?.order?.deliveryAddress?.houseNo},{" "}
                          {order?.data?.order?.deliveryAddress?.addressLine1},{" "}
                          {order?.data?.order?.deliveryAddress?.addressLine2},{" "}
                          {order?.data?.order?.deliveryAddress?.emirates},{" "}
                          {order?.data?.order?.deliveryAddress?.country}
                        </p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Location
                        </h6>
                        <p className="m-0 text-gray-500">
                          <Link
                            to={
                              order?.data?.order?.deliveryAddress?.locationUrl
                            }
                            target="_blank"
                          >
                            {order?.data?.order?.deliveryAddress?.location}
                          </Link>
                        </p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">Notes</h6>
                        <p className="m-0 text-gray-500">
                          {order?.data?.order?.notes || "No notes available"}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="btnWrpper mt-2">
                  <button
                    className={`${styles.borderedBtn} d-flex align-items-center justify-content-center w-100 btn`}
                    type="button"
                    onClick={() => setCancelConfirmation(true)}
                    disabled={
                      isUpdating || order?.data?.order?.status === "cancelled"
                    }
                  >
                    {order?.data?.order?.status === "cancelled" ? (
                      <span className="text-gray-500">Order Cancelled</span>
                    ) : (
                      "Cancel Order"
                    )}
                  </button>
                </div>
              </Col>

              <Col md="6" className="my-2">
                <div className="cardCstm bg-light rounded-3 p-2 px-3">
                  <div className="top pb-2">
                    <h6 className="m-0 fw-sbold text-base pb-1">
                      Order Summary
                    </h6>
                  </div>
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <ul className="list-unstyled pl-0 mb-0">
                        {order?.data?.order?.type === 3 && selectedMeals?.length > 0 && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Meal Price (incl. vat)
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(
                                order?.data?.order?.originalSubTotal ||
                                  selectedMeals?.order?.originalSubTotal || 0
                              )}
                            </p>
                          </li>
                        )}
                        {order?.data?.order?.totalStorePrice > 0 && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Online Order Price (incl. vat)
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(
                                order?.data?.order?.totalStorePrice
                              )}
                            </p>
                          </li>
                        )}
                        {order?.data?.order?.isLongTermApplied && (
                          <>
                            <li className="py-2 border-bottom">
                              <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="left d-flex align-items-center gap-2">
                                  <span className="icn">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1_22289)">
                                        <rect
                                          width="14"
                                          height="14"
                                          rx="7"
                                          fill="#32936F"
                                          fill-opacity="0.24"
                                        ></rect>
                                        <path
                                          d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                          fill="#32936F"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1_22289">
                                          <rect
                                            width="14"
                                            height="14"
                                            rx="7"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                  <p className="m-0 text-dark fw-normal">
                                    {
                                      order?.data?.order?.planDurationDetails
                                        ?.label
                                    }{" "}
                                    <span className="text-muted">applied</span>
                                  </p>
                                </div>
                                <div className="right">
                                  <p className="m-0 text-muted small fw-light">
                                    -
                                    {priceCurrency(
                                      order?.data?.order?.longTermDiscountValue
                                    )}
                                    {/* calculate percentage and show  */}(
                                    {`${order?.data?.order?.planDurationDetails?.discount}%`}
                                    )
                                  </p>
                                </div>
                              </div>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Discounted Price
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {priceCurrency(
                                  order?.data?.order?.longTermDiscount
                                )}
                              </p>
                            </li>
                          </>
                        )}
                        {order?.data?.order?.isPromo && (
                          <>
                            <li className="py-2 border-bottom">
                              <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="left d-flex align-items-center gap-2">
                                  <span className="icn">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1_22289)">
                                        <rect
                                          width="14"
                                          height="14"
                                          rx="7"
                                          fill="#32936F"
                                          fill-opacity="0.24"
                                        ></rect>
                                        <path
                                          d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                          fill="#32936F"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1_22289">
                                          <rect
                                            width="14"
                                            height="14"
                                            rx="7"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                  <p className="m-0 text-dark fw-normal">
                                    {order?.data?.order?.couponDetail?.code}{" "}
                                    <span className="text-muted">applied</span>
                                  </p>
                                </div>
                                <div className="right">
                                  <p className="m-0 text-muted small fw-light">
                                    -
                                    {priceCurrency(
                                      order?.data?.order?.discountPrice
                                    )}{" "}
                                    (
                                    {order?.data?.order?.couponDetail &&
                                      `${
                                        order?.data?.order?.couponDetail
                                          .promoCodeType === "userReferral" &&
                                        order?.data?.order?.userId ===
                                          order?.data?.order?.couponDetail
                                            ?.addedBy
                                          ? order.data.order.couponDetail
                                              .referralDiscountForReferrer
                                          : order.data.order.couponDetail
                                              .discountValue
                                      } ${
                                        order.data.order.couponDetail
                                          .discountType === "Percent"
                                          ? "%"
                                          : "AED"
                                      }`}
                                    )
                                  </p>
                                </div>
                              </div>
                            </li>
                          </>
                        )}
                        {order?.data?.order?.isAdvanceMacro && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Advanced Macro Fee
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(
                                order?.data?.order?.advanceMacroFees
                              )}
                            </p>
                          </li>
                        )}
                        {order?.data?.order?.subTotalAfterPromo !== undefined && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Sub total
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(order?.data?.order?.subTotalAfterPromo || 0)}
                            </p>
                          </li>
                        )}
                        {order?.data?.order?.boxPrice > 0 && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Cooler Bag Deposit
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(order?.data?.order?.boxPrice)}
                            </p>
                          </li>
                        )}
                        <li className="py-2 d-flex align-items-center justify-content-between">
                          <p className="m-0 fw-normal text-dark text-base">
                            Delivery Fee
                          </p>
                          <p className="m-0 fw-normal text-dark text-base">
                            {priceCurrency(order?.data?.order?.deliveryFees)}
                          </p>
                        </li>

                        {order?.data?.order?.isSwaped && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 font-normal text-dark text-base">
                              Swapped Amount
                            </p>
                            <p className="m-0 font-normal text-dark text-base">
                              {/* {/ ${data?.order?.boxPrice} /} */}
                              {priceCurrency(order?.data?.order?.swapedAmount)}
                            </p>
                          </li>
                        )}
                      </ul>
                    </li>
                    <li className="py-2 border-bottom">
                      <div
                        className=" py-2 px-3 d-flex align-items-center justify-content-between"
                        style={{ background: "rgb(241, 241, 234)" }}
                      >
                        <p className="m-0 fw-sbold text-dark">Total Payment</p>
                        <p className="m-0 fw-sbold text-dark">
                          {" "}
                          {priceCurrency(order?.data?.order?.payAmount)}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};

export default StoreOrderDetail;
